import React from 'react'
import { Client } from '@/types'
import { Modal } from '@/components/ui/Modal'
import { formatLicenseDate } from '@/utils/license-utils'

interface LicenseTerminateModalProps {
  client: Client
  isLoading: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const LicenseTerminateModal: React.FC<LicenseTerminateModalProps> = ({
  client,
  isLoading,
  onCancel,
  onConfirm,
}) => {
  const clientLabel = client.name || `${client.firstname} ${client.lastname}`.trim()

  return (
    <Modal
      title="Résilier la licence"
      isDanger
      confirmButtonText="Résilier"
      onCancel={onCancel}
      onConfirm={onConfirm}
      isLoading={isLoading}
      size="md"
    >
      <div className="space-y-3 text-sm text-[var(--color-text-primary)]">
        <p>
          Vous êtes sur le point de résilier la licence de{' '}
          <span className="font-medium">{clientLabel}</span>.
        </p>
        <p className="text-[var(--color-text-secondary)]">
          Cette action est définitive : la licence restera visible avec le statut « Résiliée »,
          sans possibilité de réactivation ni de transfert.
        </p>
        <div className="p-3 bg-[var(--color-gray-100)] rounded-lg space-y-1">
          <p>
            Date de souscription :{' '}
            <span className="font-medium">
              {formatLicenseDate(client.subscribedAt ?? client.createdAt)}
            </span>
          </p>
          <p className="text-[var(--color-text-secondary)]">
            La date de fin de préavis sera calculée automatiquement selon les règles de facturation
            (préavis minimum d&apos;un mois avant la fin du trimestre en cours).
          </p>
        </div>
      </div>
    </Modal>
  )
}
